// extracted by mini-css-extract-plugin
module.exports = {"modal":"jgp-2kesi","image":"jgp-3vVIJ","message":"jgp-H2i6K","button":"jgp-2nGzv"};